import { ContainerBloco, LinhaInfo, TituloBloco } from "../../../Common/styles";
import { IProposta } from "../../../../../utility/IProposta";
import { Building2, FileText } from "lucide-react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import InputEditavel from "../../../../form/InputEditavel";
import SelectEditavel from "../../../../form/SelectEditavel";

interface BlocoDetalhesProcessoProps {
    demanda?: IProposta | null;
    loading?: boolean;
    isEditing?: boolean;
    isDisabled?: boolean;
    onChange?: (campo: string, valor: any) => void;
    onBlur?: (campo: string) => void;
    errors?: Record<string, string>;
}

const naturezaOptions = [
    { value: 'Judicial', label: 'Judicial' },
    { value: 'Extrajudicial', label: 'Extrajudicial' },
    { value: 'Administrativa', label: 'Administrativa' },
];

export default function BlocoDetalhesProcesso({demanda, loading = false, isEditing = false, isDisabled = false, onChange, onBlur, errors}: BlocoDetalhesProcessoProps) {

    const handleNaturezaChange = (value: string) => {
        if (onChange) {
            onChange('natureza', value);
        }
    };

    const handleNumeroProcessoChange = (value: string) => {
        if (onChange) {
            // Remove apenas caracteres não numéricos para armazenar no banco
            // O InputMask já aplica a máscara visualmente
            const numbers = value.replace(/\D/g, '');
            onChange('numero_processo', numbers);
        }
    };

    return (
        <ContainerBloco>
            {loading ? (
                <>
                    <Skeleton height={24} width="60%" style={{ marginBottom: '12px' }} />
                    <Skeleton height={20} width="100%" style={{ marginBottom: '12px' }} />
                    <Skeleton height={20} width="100%" />
                </>
            ) : (
                <>
                <TituloBloco>Detalhes do Processo</TituloBloco>
                <>
                    <LinhaInfo>
                        <span className="label">
                            <Building2 size={16} color="#8A99A8"/>
                        Natureza:
                    </span>
                        <SelectEditavel
                            value={demanda?.natureza}
                            onChange={handleNaturezaChange}
                            onBlur={() => onBlur && onBlur('natureza')}
                            isEditing={isEditing}
                            disabled={isDisabled}
                            options={naturezaOptions}
                            placeholder="Selecionar"
                            error={errors?.natureza}
                        />
                    </LinhaInfo>
                    <LinhaInfo>
                        <span className="label">
                            <FileText size={16} color="#8A99A8"/> {demanda?.natureza === 'Judicial' ? 'Número do Processo:' : 'Número de Identificação:'}
                        </span>
                        <InputEditavel
                            value={demanda?.numero_processo}
                            onChange={handleNumeroProcessoChange}
                            onBlur={() => onBlur && onBlur('numero_processo')}
                            isEditing={isEditing}
                            disabled={isDisabled}
                            placeholder={demanda?.natureza === 'Judicial' ? "0000000-00.0000.0.00.0000" : "Número de identificação"}
                            mask={demanda?.natureza === 'Judicial' ? "9999999-99.9999.9.99.9999" : undefined}
                            error={errors?.numero_processo}
                        />
                    </LinhaInfo>
                    </>
                </>
            )}
        </ContainerBloco>
    )
}
